import React from "react";
import { Link } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../shadcn/components/ui/breadcrumb";

const Breadcrumbs = ({ breadcrumbs = [], handleClick = () => 0 }) => (
  <div role="presentation" onClick={handleClick}>
    <Breadcrumb aria-label="breadcrumb">
      <BreadcrumbList>
        {breadcrumbs.map((link, index) => {
          const displayText = link?.text || "";
          const isLast = index === breadcrumbs.length - 1;
          return (
            <React.Fragment key={link.path + displayText}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{displayText}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink
                    render={
                      <Link to={link.path} state={{ ...(link.state || {}) }} />
                    }
                  >
                    {displayText}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  </div>
);

export default Breadcrumbs;
